(function () {
    'use strict';

    console.realWarn = console.warn;
    console.warn = function (message) {
        if (message.indexOf("ARIA") == -1) {
            console.realWarn.apply(console, arguments);
        }
    };

    angular
        .module('garnaCabinet', [
            'wsl.core',
            'wsl.router',
            'wsl.restAPI',
            'wsl.localStorage',
            'wsl.nounEnding',
            'wsl.notification',

            'ngAria',
            'ngMaterial',

            'oc.lazyLoad',
            'infinite-scroll'
        ])
        .constant('jQuery', jQuery)
        .run(runCabinet);

    runCabinet.$inject = ['routerSetup', 'notificationSetup'];
    /* @ngInject */
    function runCabinet(routerSetup, notificationSetup) {
        routerSetup.run();
       // notificationSetup.run();
    }
})();
